import React, { useRef, useState } from "react";
import dynamic from "next/dynamic";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import classes from "@styles/carousel/carousel.module.css";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { NoSsr, useMediaQuery } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
const CarouselImage = dynamic(() => import("./CarouselImage"), {
  ssr: false
});
const CarouselItem = ({
  data,
  priority,
  positionLink
}) => {
  const router = useRouter();
  return <Link href={data?.bannerLink + positionLink} hrefLang={router.locale} rel="noreferrer alternate" target="_blank" data-sentry-element="Link" data-sentry-component="CarouselItem" data-sentry-source-file="Carousel.jsx">
      <CarouselImage eventData={data} priority={priority} data-sentry-element="CarouselImage" data-sentry-source-file="Carousel.jsx" />
    </Link>;
};
export default function Carousel({
  data,
  position
}) {
  const sliderRef = useRef();
  const [reachedStart, setReachedStart] = useState(true);
  const smallScreen = useMediaQuery("(max-width:700px)");
  const [positionLink, setPositionLink] = useState(`&utm_medium=${smallScreen ? "mobile_web" : "desktop_web"}${position ? "&utm_source=" + position : ""}`);

  //=========== SLIDER SETTINGS ==========//
  let settings;
  settings = {
    infinite: false,
    speed: 500,
    variableWidth: true,
    slidesToScroll: 2,
    arrows: false,
    dots: false,
    afterChange: currentSlide => {
      if (currentSlide === 0) setReachedStart(true);else if (reachedStart) setReachedStart(false);
    }
  };
  if (smallScreen) {
    settings.slidesToScroll = 1;
  }
  function next() {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  }
  function previous() {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  }
  if (!data) {
    return "";
  }
  return <div className={classes.root} data-sentry-component="Carousel" data-sentry-source-file="Carousel.jsx">
      {!reachedStart && <div className={classes.leftArrow}>
          <NoSsr>
            <ArrowBack onClick={previous} />
          </NoSsr>
        </div>}

      <div className={classes.rightArrow}>
        <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="Carousel.jsx">
          <ArrowForward onClick={next} data-sentry-element="ArrowForward" data-sentry-source-file="Carousel.jsx" />
        </NoSsr>
      </div>

      <Slider ref={c => sliderRef.current = c} {...settings} data-sentry-element="Slider" data-sentry-source-file="Carousel.jsx">
        {data.map((item, idx) => {
        return <>
              <CarouselItem key={idx} data={item} positionLink={positionLink} />
            </>;
      })}
      </Slider>
    </div>;
}